import type { NewsItem } from '../types/media';

export const newsList: NewsItem[] = [
  {
    id: 'n-001',
    title: '《星海远征》点映口碑爆棚，科幻视效被赞"国产天花板"',
    summary: '影片点映场结束后观众自发鼓掌超过两分钟，多个平台开分均突破八点五分，被不少影迷称为年度最值得走进影院的科幻作品。',
    category: '电影资讯',
    date: '2026-10-08',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20premiere%20red%20carpet%20with%20spotlights%20and%20a%20glowing%20space%20backdrop%2C%20elegant%20premiere%20atmosphere%2C%20warm%20and%20teal%20tones%2C%20editorial%20photo&width=800&height=500&seq=mc-news-001&orientation=landscape',
    author: '影讯组',
    relatedId: 'm-001',
  },
  {
    id: 'n-002',
    title: '《山海长歌》定档十月，曝终极预告再现仙侠美学',
    summary: '官方发布终极预告，长达三分钟的镜头展现宏大世界观与唯美特效，主演阵容同框亮相，引发全网热议。',
    category: '剧集预告',
    date: '2026-10-07',
    cover: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20fantasy%20drama%20key%20visual%20with%20misty%20mountains%20and%20a%20warrior%2C%20teal%20and%20gold%20tones%2C%20cinematic%20poster%20style&width=800&height=500&seq=mc-news-002&orientation=landscape',
    author: '剧集观察',
    relatedId: 't-001',
  },
  {
    id: 'n-003',
    title: '《都市夜归人》幕后特辑公开，动作戏全程实拍不用替身',
    summary: '主创团队公开拍摄幕后，主演为呈现真实追车与打斗场面坚持亲自上阵，敬业程度获得剧组一致认可。',
    category: '幕后花絮',
    date: '2026-10-06',
    cover: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20a%20crime%20film%20with%20film%20cameras%20and%20neon%20lit%20alley%20set%2C%20moody%20teal%20orange%20tones%2C%20documentary%20photo&width=800&height=500&seq=mc-news-003&orientation=landscape',
    author: '现场直击',
    relatedId: 'm-003',
  },
  {
    id: 'n-004',
    title: '年度口碑剧《黑白之间》收官，观众直呼"后劲太大"',
    summary: '大结局播出后登上多个热搜榜单，关于正义与选择的话题讨论持续升温，被认为刷新了国产悬疑剧的叙事高度。',
    category: '剧评',
    date: '2026-10-05',
    cover: 'https://readdy.ai/api/search-image?query=Noir%20interrogation%20room%20with%20harsh%20light%20and%20long%20shadows%2C%20high%20contrast%20crime%20drama%20still%2C%20cinematic&width=800&height=500&seq=mc-news-004&orientation=landscape',
    author: '剧评人·陆知',
    relatedId: 't-003',
  },
  {
    id: 'n-005',
    title: '《美食奇遇记》回归，新一季走进二十四座小城',
    summary: '节目组公布新一季拍摄路线，将深入二十四座特色小城寻味，用镜头记录街头巷尾最真实的人间烟火。',
    category: '综艺资讯',
    date: '2026-10-04',
    cover: 'https://readdy.ai/api/search-image?query=Bustling%20night%20market%20with%20warm%20glowing%20food%20stalls%20and%20steam%2C%20cozy%20documentary%20photo%2C%20rich%20warm%20colors&width=800&height=500&seq=mc-news-005&orientation=landscape',
    author: '综艺前线',
    relatedId: 'v-003',
  },
  {
    id: 'n-006',
    title: '《长安幻夜》美术概念图曝光，还原盛唐夜色惊艳网友',
    summary: '官方释出多张美术概念图，从街市灯会到宫阙飞檐无不考究，网友称赞"每一帧都能当壁纸"。',
    category: '视觉物料',
    date: '2026-10-03',
    cover: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20city%20lantern%20festival%20at%20night%20with%20golden%20lanterns%20and%20misty%20rooftops%2C%20warm%20golden%20tones%2C%20concept%20art%20style&width=800&height=500&seq=mc-news-006&orientation=landscape',
    author: '美术观察',
    relatedId: 'm-004',
  },
  {
    id: 'n-007',
    title: '《星光音乐会》第五期：民谣专场温暖收官',
    summary: '本期节目邀请多位民谣音乐人同台，用一把木吉他讲述平凡人的故事，现场观众数度落泪。',
    category: '综艺资讯',
    date: '2026-10-02',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20intimate%20live%20music%20stage%20with%20acoustic%20guitar%20and%20soft%20amber%20spotlight%2C%20concert%20photo%2C%20cozy%20mood&width=800&height=500&seq=mc-news-007&orientation=landscape',
    author: '音乐现场',
    relatedId: 'v-002',
  },
  {
    id: 'n-008',
    title: '专访《迷雾档案》导演：悬疑不是炫技，而是陪着观众一起找答案',
    summary: '导演分享创作初衷，坦言希望观众在观影过程中始终保持思考，而不是被动接受一个被解释好的结局。',
    category: '深度专访',
    date: '2026-10-01',
    cover: 'https://readdy.ai/api/search-image?query=Director%20interview%20setting%20with%20soft%20studio%20light%20and%20a%20film%20camera%2C%20moody%20neutral%20tones%2C%20editorial%20portrait%20style&width=800&height=500&seq=mc-news-008&orientation=landscape',
    author: '人物周刊',
    relatedId: 'm-006',
  },
  {
    id: 'n-009',
    title: '《归途有风》温暖开播，聚焦普通家庭的团圆故事',
    summary: '剧集以细腻笔触描绘三兄妹回乡重启生活的过程，被评价为"最像春节档的一部长剧"。',
    category: '剧集开播',
    date: '2026-09-30',
    cover: 'https://readdy.ai/api/search-image?query=Golden%20wheat%20field%20with%20a%20small%20farmhouse%20at%20sunset%2C%20warm%20nostalgic%20drama%20still%2C%20soft%20light&width=800&height=500&seq=mc-news-009&orientation=landscape',
    author: '剧集观察',
    relatedId: 't-002',
  },
  {
    id: 'n-010',
    title: '《追风少年》片尾曲上线，旋律治愈无数追梦人',
    summary: '片尾曲上线后一路攀升至音乐榜单前列，歌词中"风会记得"被大量观众用作弹幕与评论，成为本年度热门台词。',
    category: '音乐物料',
    date: '2026-09-29',
    cover: 'https://readdy.ai/api/search-image?query=Young%20runner%20silhouette%20on%20an%20empty%20track%20at%20golden%20sunset%2C%20warm%20orange%20sky%2C%20inspiring%20cinematic%20still&width=800&height=500&seq=mc-news-010&orientation=landscape',
    author: '音乐现场',
    relatedId: 'm-005',
  },
];